export enum AddressVariables {
  BorrowerStreetAddress = 'borrower_street_address',
  BorrowerCity = 'borrower_city',
  BorrowerState = 'borrower_state_or_province',
  BorrowerZipCode = 'borrower_zip_or_postal_code',
  BorrowerCounty = 'borrower_county',
  MoveInDate = 'move_in_date',

  BorrowerPreviousStreetAddress1 = 'borrower_previous_street_address_1',
  BorrowerPreviousCity1 = 'borrower_previous_city_1',
  BorrowerPreviousState1 = 'borrower_previous_state_1',
  BorrowerPreviousZipCode1 = 'borrower_previous_zip_code_1',
  BorrowerPreviousMoveInDate1 = 'borrower_previous_move_in_date_1',

  CoborrowerPreviousStreetAddress1 = 'coborrower_previous_street_address_1',
  CoborrowerPreviousCity1 = 'coborrower_previous_city_1',
  CoborrowerPreviousState1 = 'coborrower_previous_state_1',
  CoborrowerPreviousZipCode1 = 'coborrower_previous_zip_code_1',
  CoborrowerPreviousMoveInDate1 = 'coborrower_previous_move_in_date_1',
  // it's not LOS variable. It's used only for AddressInfoForm
  CoborrowerPreviousAddress1SameAsBorrower = 'coborrower_previous_address_same_as_borrower_1',
}
